import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetUserAction} from '../action';

function* execute({payload: {userId}}: GetUserAction): SagaIterator {
    const response = yield* call(Api.getUserProfile, {userProfileId: userId});

    if (response.isSuccess) {
        yield* put(adminAction.getUserSuccess(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('loadUserDetail')));
    }
}

/** Runs the admin saga that loads the selected user detail. */
export function* getUserSaga(): SagaIterator {
    yield takeLatestF('admin/GET_USER', execute);
}
